import "../styles/main.css";
import "../styles/hover.css";

const AboutMeComponent = () => {
  return (
    <>
        <section>

            
        </section>
    </>
  )
}

export default AboutMeComponent